import "@expo/match-media";
import { useMediaQuery } from "react-responsive";
import { breakpoint } from "../styles/theme";

export default () => useMediaQuery({ minWidth: breakpoint.desktop });
